// Kept home (Selling Property page, Status Retained): does the mortgage payment
// the servicer collects (the credit-report payment) already include the
// property taxes and insurance? This decides which costs LANIS adds on top of
// the payment, matching the 1003 / MISMO 3.4 "Monthly Insurance, Taxes,
// Association Dues, etc. if not included in Monthly Mortgage Payment".
// Blank (existing loans) behaves like ESCROW_NOT_IN_PAYMENT, which is how LANIS
// has always counted these homes.
export const ESCROW_NOT_IN_PAYMENT = "0";
export const ESCROW_IN_PAYMENT = "1";
export const NO_MORTGAGE = "2";

export default Object.freeze({
  [ESCROW_IN_PAYMENT]: "Yes - taxes and insurance are in the payment",
  [ESCROW_NOT_IN_PAYMENT]: "No - the payment is principal and interest only",
  [NO_MORTGAGE]: "No mortgage on this home (free and clear)"
});
